import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
// TODO(ionic-10): '@ionic/angular/lazy' and IonicModule are deprecated in Ionic 9
// (see node_modules/@ionic/angular/README.md) and will be removed in a future
// major. Migrate to standalone Ion* component imports + provideIonicAngular().
import { IonicModule } from '@ionic/angular/lazy';
import { TranslateModule } from '@ngx-translate/core';
import player from 'lottie-web';
import { ArrowButtonComponent } from './components/arrow-button/arrow-button.component';
import { AverageSunComponent } from './components/average-sun/average-sun.component';
import { BatterieIconComponent } from './components/batterie-icon/batterie-icon.component';
import { BatterieInfoComponent } from './components/batterie-info/batterie-info.component';
import { BatteryTransferComponent } from './components/battery-transfer/battery-transfer.component';
import { BottomButtonsComponent } from './components/bottom-buttons/bottom-buttons.component';
import { CardCompactComponent } from './components/card-compact/card-compact.component';
import { CardContainerComponent } from './components/card-container/card-container.component';
import { CardComponent } from './components/card/card.component';
import { DeviceCardComponent } from './components/device-card/device-card.component';
import { DeviceDataComponent } from './components/device-data/device-data.component';
import { DeviceTypeLabelComponent } from './components/device-type-label/device-type-label.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { EnergyInfoComponent } from './components/energy-info/energy-info.component';
import { FadingSpanComponent } from './components/fading-span/fading-span.component';
import { HeaderComponent } from './components/header/header.component';
import { InformationListComponent } from './components/information-list/information-list.component';
import { InformationTemplateComponent } from './components/information-template/information-template.component';
import { InputComponent } from './components/input/input.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ModalCardComponent } from './components/modal-card/modal-card.component';
import { ModalItemPickerComponentComponent } from './components/modal-item-picker/modal-item-picker.component';
import { ModalTimeRangePickerComponentComponent } from './components/modal-time-range-picker/modal-time-range-picker.component';
import { NavContainerComponent } from './components/nav-container/nav-container.component';
import { PanelsProductionComponent } from './components/panels-production/panels-production.component';
import { RadioInputComponent } from './components/radio-input/radio-input.component';
import { RatioBarComponent } from './components/ratio-bar/ratio-bar.component';
import { SuccessTemplateComponent } from './components/success-template/success-template.component';
import { TimespanComponent } from './components/timespan/timespan.component';
import { ToogleComponent } from './components/toggle-button/toggle-button.component';
import { SkeletonComponent } from './components/skeleton/skeleton.component';
import { BatteryPausedInfoDirective } from './components/device-data/battery-paused-info.directive';

/**
 *
 * lottie
 *
 */
export function playerFactory() {
    return player;
}

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        IonicModule,
        ReactiveFormsModule,
        AverageSunComponent,
        ArrowButtonComponent,
        InformationListComponent,
        TimespanComponent,
        CardComponent,
        InputComponent,
        LoaderComponent,
        HeaderComponent,
        CardContainerComponent,
        DeviceDataComponent,
        BatteryPausedInfoDirective,
        RatioBarComponent,
        SkeletonComponent,
        EnergyInfoComponent,
        EmptyStateComponent,
        NavContainerComponent,
        PanelsProductionComponent,
        BatteryTransferComponent,
        ModalCardComponent,
        FadingSpanComponent,
        CardCompactComponent,
        BatterieIconComponent,
        ToogleComponent,
        DeviceTypeLabelComponent,
        BatterieInfoComponent,
        InformationTemplateComponent,
        SuccessTemplateComponent,
        BottomButtonsComponent,
        DeviceCardComponent,
        RadioInputComponent,
        ModalItemPickerComponentComponent,
        ModalTimeRangePickerComponentComponent,
    ],
    declarations: [],
    exports: [
        AverageSunComponent,
        ArrowButtonComponent,
        InformationListComponent,
        TimespanComponent,
        CardComponent,
        InputComponent,
        LoaderComponent,
        HeaderComponent,
        CardContainerComponent,
        DeviceDataComponent,
        BatteryPausedInfoDirective,
        RatioBarComponent,
        SkeletonComponent,
        EnergyInfoComponent,
        EmptyStateComponent,
        NavContainerComponent,
        PanelsProductionComponent,
        BatteryTransferComponent,
        ModalCardComponent,
        FadingSpanComponent,
        CardCompactComponent,
        BatterieIconComponent,
        ToogleComponent,
        DeviceTypeLabelComponent,
        InformationTemplateComponent,
        SuccessTemplateComponent,
        BottomButtonsComponent,
        DeviceCardComponent,
        RadioInputComponent,
        ModalItemPickerComponentComponent,
        ModalTimeRangePickerComponentComponent,
    ],
})
export class UiMobileModule {}
